/**
 * Client-side CAPTCHA validation helper.
 *
 * Sends the Turnstile token to our server-side API route for verification
 * via Cloudflare's siteverify endpoint. This keeps the secret key server-only
 * while allowing client-side auth code to gate on CAPTCHA validity.
 *
 * When no token is provided, the server-side handler decides: if
 * TURNSTILE_SECRET_KEY is not configured it passes through (development),
 * otherwise it rejects (bot likely bypassed the widget).
 */

export async function validateCaptchaToken(token: string | undefined | null): Promise<void> {
  const res = await fetch('/api/auth/verify-captcha', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token: token ?? undefined }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => null);
    const message = data?.error || 'CAPTCHA verification failed. Please try again.';
    throw new Error(message);
  }
}
